import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = (id: string) => ["episode-content", id];

const useEpisodeContentQuery = (
  id: string,
  options?: {
    isEnabled?: boolean;
  },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(id),
    queryFn: () => api.getEpisodeContent(id),
    enabled: options?.isEnabled,
  });
};

export default useEpisodeContentQuery;
